module.exports = __webpack_public_path__ + "img/starry.fd6ea29e.png";